import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
// Backstage UI's stylesheet: its token layer, a base layer (border-box sizing,
// body font and background) and the component styles of every @backstage/ui
// component, upstream pages included. Without it those components render in
// browser defaults (PLAT-689). Loaded first; App.tsx's tokens.css and
// bui-bridge.css are unlayered, so they outrank its layers whatever the order.
import '@backstage/ui/css/styles.css';
import './globalStyles.css';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
